
<complete-checklist-tab [tabIndex]="tabIndex" ></complete-checklist-tab>

<div  *ngIf="completeCheckListDetails && tabIndex==0" >
        <complete-checklist-general [checklistCompleteDetails]="completeCheckListDetails"
        [responsiblePersonList]="responsibleperson"  (onCompleteGeneralCheckList)="onCompleteGeneralCheckList($event)"  ></complete-checklist-general>
</div>
